<template>
  <div class="top-faqs">
    <section :class="wrapperClass">
      <section class="desc">
        <h2 :class="title" class="title-2">Top questions</h2>
      </section>
      <section :class="innerClass" v-if="faqs">
        <section v-if="$mq === 'desktop'" class="last-col">
          <section class="faq-card">
            <section class="card-body">
              <div class="title-card">
                {{ faqs[0].question }}
              </div>
              <div class="description">
                {{ faqs[0].answer }}
              </div>
            </section>
          </section>
        </section>
        <section v-if="$mq === 'desktop'" class="last-col">
          <section class="faq-card">
            <section class="card-body">
              <div class="title-card">
                {{ faqs[1].question }}
              </div>
              <div class="description">
                {{ faqs[1].answer }}
              </div>
            </section>
          </section>
        </section>
      </section>
      <section v-if="$mq !== 'desktop'">
        <section class="last-col">
          <section class="faq-card">
            <section class="card-body">
              <div class="title-card">
                {{ faqs[0].question }}
              </div>
              <div class="description">
                {{ faqs[0].answer }}
              </div>
            </section>
          </section>
        </section>
        <section class="last-col">
          <section class="faq-card">
            <section class="card-body">
              <div class="title-card">
                {{ faqs[1].question }}
              </div>
              <div class="description">
                {{ faqs[1].answer }}
              </div>
            </section>
          </section>
        </section>
      </section>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      faqs: [
        {
          question: "Who sees my participation and results?",
          answer:
            "If you are individually using Workera then you decide whether you want to share your results with others. If your company has sponsored Workera for you then the program administrators at your company determine who can see your participation and results."
        },
        {
          question: "Is Workera free?",
          answer:
            "Yes, Workera offers a free basic solution for individuals looking to achieve their career goals. For organizations seeking to transform their Data-AI capabilities, Workera for Enterprise is the right solution."
        }
      ]
    };
  },
  computed: {
    wrapperClass() {
      switch (this.$mq) {
        case "desktop":
          return "wrapper";
        case "tablet":
          return "wrapper tablet";
        default:
          return "wrapper mobile";
      }
    },
    innerClass() {
      switch (this.$mq) {
        case "desktop":
          return "column--duo--equivalent";
        default:
          return "single";
      }
    },
    title() {
      switch (this.$mq) {
        case "desktop":
          return "title";
        default:
          return "title-mobile";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-faqs {
  background-color: $light-grey;
  display: flex;
  align-content: center;
  position: relative;

  .background {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .wrapper {
    padding: 4rem 1.5rem;

    > section {
      .last-col {
        margin-top: 2rem;

        .faq-card {
          @include rounded-corner(5px);
          padding: 0;
          background: white;

          width: 95%;
          height: 100%;

          .title-card {
            margin-bottom: 1.4rem;
            font-weight: 700;
            font-size: 18px;
            line-height: 23.54px;
            letter-spacing: 0.1px;
          }

          .description {
            // margin-bottom: 1.4rem;
            font-weight: 600;
            font-size: 18px;
            line-height: 23.54px;
            //letter-spacing: -0.8px;
          }
        }
      }
    }
  }

  .tablet {
    padding: 4rem 1.5rem;
  }

  .mobile {
    background-image: none;
    padding: 2rem 1.5rem;
    > section {
      .first-col {
        .title-2 {
          margin-bottom: 1%;
        }
      }

      .last-col {
        .faq-card {
          padding: 0rem;
          max-width: 95%;
          margin-top: 2rem;

          .title-4 {
            font-weight: 700;
            font-size: 20px;
            line-height: 26.16px;
            letter-spacing: 0.1px;
          }

          .description-2 {
            font-weight: 600;
            font-size: 18px;
            line-height: 23.54px;
            //letter-spacing: -0.8px;
          }
        }
      }

      .button-section {
        display: flex;

        .yellow-button-1 {
          margin: auto;
          margin-top: 2rem;
        }
      }
    }
  }
}
</style>
